import {Slot} from "../../../../../../../../../server/src/base/entities/leasing/calendar/Slot";
import {IUnavailabilityService} from "../../../../../../domain/leasing/IUnavailabilityService";
import {RemovedSlot} from "../../../../../../../../../server/src/base/entities/leasing/unaivailability/RemovedSlot";
import {Unavailability} from "../../../../../../../../../server/src/base/entities/leasing/unaivailability/Unavailability";
import {RemovedSlots} from "../../../../../../../../../server/src/base/entities/leasing/unaivailability/RemovedSlots";

export class SlotsSelectionHandler {

    private unavailabilityService:IUnavailabilityService;

    private slotsToBeAdded:Array<RemovedSlot>;
    private slotsToBeRemoved:Array<RemovedSlot>;
    private unavailability:Unavailability;

    constructor(unavailabilityService:IUnavailabilityService, unavailability:Unavailability){
        this.unavailabilityService = unavailabilityService;
        this.unavailability = unavailability;
        this.slotsToBeAdded = [];
        this.slotsToBeRemoved = [];
    }

    public SelectSlot(slot:Slot){
        if(this.Contains(this.slotsToBeRemoved, slot)){
            this.slotsToBeRemoved = this.Remove(this.slotsToBeRemoved, slot);
        }else{
            this.slotsToBeAdded.push(this.Build(slot));
        }
    }

    public UnselectSlot(slot:Slot){
        if(this.Contains(this.slotsToBeAdded, slot)){
            this.slotsToBeAdded = this.Remove(this.slotsToBeAdded, slot);
        }else{
            this.slotsToBeRemoved.push(this.Build(slot));
        }
    }

    public Handle():Promise<void>{
        if(this.slotsToBeAdded.length == 0 && this.slotsToBeRemoved.length == 0){
            return Promise.resolve();
        }


        if(this.slotsToBeAdded.length > 0){
            return this.unavailabilityService.CreateUnavailability(new RemovedSlots(this.slotsToBeAdded)).then(() => {
                if(this.slotsToBeRemoved.length > 0){
                    return this.unavailabilityService.RemoveUnavailability(new RemovedSlots(this.slotsToBeRemoved));
                }else{
                    return Promise.resolve();
                }
            })
        }else{
            if(this.slotsToBeRemoved.length > 0){
                return this.unavailabilityService.RemoveUnavailability(new RemovedSlots(this.slotsToBeRemoved));
            }
        }


    }

    private Contains(slots:Array<RemovedSlot>, slot:Slot):boolean{
        for(let removedSlot of slots){
            if(removedSlot.slot.Value() == slot.Value()){
                return true;
            }
        }
        return false;
    }

    private Remove(slots:Array<RemovedSlot>, slot:Slot):Array<RemovedSlot>{
        let index = 0;
        for(let removedSlot of slots) {
            if (removedSlot.slot.Value() == slot.Value()) {
                break;
            }
            index++;
        }
        slots.splice(index, 1);
        return slots;
    }

    private Build(slot:Slot):RemovedSlot{
        let removedSlot:RemovedSlot = new RemovedSlot();
        removedSlot.slot = slot;
        removedSlot.unavailabilityId = this.unavailability.id;
        return removedSlot;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/unavailability/SlotsSelectionHandler.ts